import { Group, Stack, Table, Text, Tooltip } from '@mantine/core'
import { filter, isArray, join, map } from 'lodash'
import React, { ReactElement, useMemo } from 'react'

import { Label } from '../../../../1stlog-ui/src/components/Field'
import { formatDecimalNumber } from '../../../../1stlog-ui/src/utils/format'
import HazmatLabel from '../HazmatLabel'

type ItemProps = {
  item: any
}

const Block = ({
  label,
  value,
  children,
}: {
  label: string
  value?: any
  children?: any
}): ReactElement => {
  return (
    <div className="text-center">
      <Stack spacing={0}>
        {/* <Text color="dimmed">{label}</Text> */}
        <Label>{label}</Label>
        <div>
          <h5 className="mt-1 mb-0">{value || children}</h5>
        </div>
      </Stack>
    </div>
  )
}

export const Item = (props: ItemProps): ReactElement => {
  const { item } = props

  const {
    unNumber,
    hazardousGoodName,
    description,
    descriptionSpecialProvision,
    additionalDescription,
    dangerLabelModelMain,
    dangerLabelModelSecondary1,
    dangerLabelModelSecondary2,
    dangerLabelModelSecondary3,
    transportCategory,
    tunnelLimitation,
    tunnelCode,
    isEnvironmentalHazardous,
    isLiter,
    nettoWeightOrLiter,
    packagingGroupName,
    packageDescription,
    amount,
    unit,
    packagingGroup,
    packaging,
    count,
    identificationMarkings = [],
    environmentalHazard,
    classificationCode,
    explosiveMass,
    limitedAmount,
    isExceptedQuantitiy,
    calculatedPoints,
    packagingType,
    class: classClass,
    classCode,
    pointMultiplicator,
    allowedFor1000PointTransport,
    limitedQuantityEnabled,
    amountUnit,
  } = item

  const points = useMemo(() => {
    if (pointMultiplicator && allowedFor1000PointTransport) {
      return amount * pointMultiplicator
    }
  }, [pointMultiplicator, allowedFor1000PointTransport])

  const hazardLabels = useMemo(() => {
    const result = [
      ...(isArray(identificationMarkings) ? identificationMarkings : []),
    ]
    if (result.length < 1) {
      if (dangerLabelModelMain && dangerLabelModelMain !== '') {
        result.push(dangerLabelModelMain)
      }
      if (dangerLabelModelSecondary1 && dangerLabelModelSecondary1 !== '') {
        result.push(dangerLabelModelSecondary1)
      }
      if (dangerLabelModelSecondary2 && dangerLabelModelSecondary2 !== '') {
        result.push(dangerLabelModelSecondary2)
      }
      if (dangerLabelModelSecondary3 && dangerLabelModelSecondary3 !== '') {
        result.push(dangerLabelModelSecondary3)
      }
    }
    if (result.length < 1) {
      result.push(item.class)
    }
    if (environmentalHazard || isEnvironmentalHazardous) {
      result.push('env')
    }
    return filter(result, Boolean)
  }, [identificationMarkings])

  return (
    <>
      <div style={{ display: 'flex' }}>
        <div style={{ flex: '1' }}>
          <Stack spacing="lg">
            <Group>
              <Block label="UN-Nr." value={unNumber} />
              <Block label="Inhaltsbeschreibung">
                <Tooltip label={hazardousGoodName || description}>
                  <Text truncate maw={500}>
                    {hazardousGoodName || description}
                  </Text>
                </Tooltip>
              </Block>
              {/* <Block label="Klasse (Code)">
              {classClass ?? join(identificationMarkings || [], ', ')} (
              {classificationCode ?? classCode})
            </Block> */}
              {count > 1 && <Block label="Anzahl">{count}</Block>}

              {(descriptionSpecialProvision || additionalDescription) && (
                <Block
                  label={i18n.t('technical_naming', 'Technische Benennung')}
                >
                  {descriptionSpecialProvision || additionalDescription}
                </Block>
              )}
              {/* <div
            className="flex-fill"
            style={{ display: 'flex', justifyContent: 'right' }}
          ></div> */}
              {/* <Block label="Klassen-Code">{classificationCode ?? classCode}</Block> */}

              {/* <Block label="Verpackungs-Gruppe">
              {packagingGroupName || packagingGroup || 'Keine'}
            </Block> */}
              {/* <Block label="Beförderungs-Kategorie">{transportCategory}</Block> */}
              {/* <Block label="Tunnel-Limitierung">
              {tunnelCode || tunnelLimitation}
            </Block> */}
              <Block label="Menge">
                {nettoWeightOrLiter && (
                  <span>
                    {nettoWeightOrLiter} {isLiter ? 'Liter' : 'kg'}
                  </span>
                )}
                {amount && (
                  <span>
                    {formatDecimalNumber(parseFloat(amount || 0), 2, 2)}{' '}
                    {unit ||
                      (amountUnit && (amountUnit === 'l' ? 'Liter' : 'kg'))}
                  </span>
                )}
                {/* {explosiveMass > 0 && (
            <div>
              ({parseFloat(explosiveMass || 0).toFixed(2)}{' '}
              {unit || isLiter ? 'Liter' : 'kg'} explosiv)
            </div>
          )} */}
              </Block>
              {explosiveMass > 0 && (
                <Block label={i18n.t('explosive_mass', 'Explosive Masse')}>
                  <div>
                    {formatDecimalNumber(parseFloat(explosiveMass || 0), 2, 2)}{' '}
                    {unit || isLiter ? 'Liter' : 'kg'}
                  </div>
                </Block>
              )}
              {/* <Block label="Verpackungs-Art">
              {packageDescription || packaging || packagingType}
            </Block> */}
              {/* <Block label="Punkte">
              {limitedAmount || isExceptedQuantitiy
                ? 'Begrenzte Menge'
                : calculatedPoints ?? points}
            </Block> */}
            </Group>
            {/* <Divider mt={20} w="50%" ml="25%" /> */}
            <Group>
              {map(hazardLabels, (label) => (
                <HazmatLabel label={label} size={150} />
              ))}
            </Group>
          </Stack>
        </div>
        <div className="ml-2">
          <Table>
            <tbody>
              <tr>
                <td>
                  <Text color="dimmed">Klasse (Code)</Text>
                </td>
                <td>
                  <Text style={{ whiteSpace: 'nowrap' }}>
                    {classClass ?? join(identificationMarkings || [], ', ')} (
                    {classificationCode ?? classCode})
                  </Text>
                </td>
              </tr>
              <tr>
                <td>
                  <Text color="dimmed">Verpackungsgruppe</Text>
                </td>
                <td>{packagingGroupName || packagingGroup || 'Keine'}</td>
              </tr>
              <tr>
                <td>
                  <Text color="dimmed">Beförderungskategorie</Text>
                </td>
                <td>{transportCategory}</td>
              </tr>
              <tr>
                <td>
                  <Text color="dimmed">Tunnel-Limitierung</Text>
                </td>
                <td>{tunnelCode || tunnelLimitation}</td>
              </tr>
              <tr>
                <td>
                  <Text color="dimmed">Verpackungsart</Text>
                </td>
                <td>{packageDescription || packaging || packagingType}</td>
              </tr>
              <tr>
                <td>
                  <Text color="dimmed">Punkte</Text>
                </td>
                <td>
                  <Text style={{ whiteSpace: 'nowrap' }}>
                    {limitedQuantityEnabled ||
                    limitedAmount ||
                    isExceptedQuantitiy
                      ? 'Begrenzte Menge'
                      : calculatedPoints ?? points}
                  </Text>
                </td>
              </tr>
              <tr>
                <td>
                  <Text color="dimmed">Umweltgefährdend</Text>
                </td>
                <td>
                  <Text style={{ whiteSpace: 'nowrap' }}>
                    {environmentalHazard || isEnvironmentalHazardous
                      ? 'Ja'
                      : 'Nein'}
                  </Text>
                </td>
              </tr>
            </tbody>
          </Table>
        </div>
      </div>
    </>
  )
}
